export default __webpack_public_path__ + "img/bg_group-4f2fced91a5b877baa516c5258da77f7.png";